"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REGISTER_TYPE = exports.RAML_RESOLVER_TYPE = exports.RAML_CREATE_TYPE = exports.OAUTH2_RUN_TYPE = exports.OAUTH2_RESOLVE_TYPE = exports.NOTEBOOK_TYPE = exports.ADD_EXTRA_LIB_TYPE = void 0;
var ADD_EXTRA_LIB_TYPE = exports.ADD_EXTRA_LIB_TYPE = 'add-extra-lib';
var NOTEBOOK_TYPE = exports.NOTEBOOK_TYPE = 'notebook';
var REGISTER_TYPE = exports.REGISTER_TYPE = 'register';
var OAUTH2_RUN_TYPE = exports.OAUTH2_RUN_TYPE = 'oauth2-run';
var OAUTH2_RESOLVE_TYPE = exports.OAUTH2_RESOLVE_TYPE = 'oauth2-resolve';
var RAML_RESOLVER_TYPE = exports.RAML_RESOLVER_TYPE = 'raml-resolver';
var RAML_CREATE_TYPE = exports.RAML_CREATE_TYPE = 'raml-create';
//# sourceMappingURL=types.js.map